import { render } from "./GeneralComment.vue?vue&type=template&id=fae9c1ea"
import script from "./GeneralComment.vue?vue&type=script&lang=js"
export * from "./GeneralComment.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/nchsaet-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__